/*
 * Copyright (c) 2024 CalAmp Corp.  All Rights Reserved
 */
import React, {useMemo} from 'react';
import {useHasMounted} from '@ion/core/src/hooks/useHasMounted';
import BoundaryLayer from '@ion/dls/src/maps/layers/BoundaryLayer';
import {MapContainerProps} from '@ion/dls/src/maps/types/types';
import useBoundaryFilter from '@ion/ion-suite/src/routes/tracking/hooks/tracking/useBoundaryFilter';

const BoundaryLayerContainer = ({map, view}: MapContainerProps) => {
  const isMounted = useHasMounted(null as any);
  const {boundary} = useBoundaryFilter({});

  const layerProps = useMemo(() => ({boundary}), [boundary]);
  
  if (isMounted) {
    return (
      <BoundaryLayer isFMTracking
        map={map}
        view={view}
        boundaryLayerProps={layerProps as any} />
    );
  }
};

export default BoundaryLayerContainer;
